

  <form #disbursementForm="ngForm" class="add_disurment_middle_css" (ngSubmit)="addUpdateDisbursement(disbursementForm)" novalidate>
    <div class="col-sm-12 p-0">
      <div class="add-disbursement-popup">
        <div class="modal-content">
          <div class="cmn-modal-header">
            <h4 class="modal-header-title">{{ titlePopUp }}</h4>
          </div>
          <div class="cmn-modal-content">
            <div class="form-group form-group-sm"  *ngIf="isOpenedFromQuickAction">
              <div class="row align-items-top">
                  <h6 class="cmn-form-label mb-0 text-left col-3 disbursement-kc-cmd">Client<span class="color_field">*</span></h6>
                  <div class="col-7">
                    <div class="form-select-container client-dropdown-container">
                        <ng-select 
                            [items]="disbursementClientList" class="cmn-ngselect wthout-ellipsis-option"
                            bindLabel="clientName"
                            bindValue="clientId"
                            #clientDropdown="ngModel"
                            [(ngModel)]="disbursement.clientId"
                            name="clientDropdown" 
                            placeholder="Select client"
                            [selectOnTab]="true" 
                            [virtualScroll]="true"
                            [searchFn]="clientSearchFn"
                            (change)="disbursementClientDropdownChange($event)"
                            (clear)="disbursementClientDropdownClear()"
                            required>
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                <span>{{item.clientName}} ({{item.clientCode}})</span>
                            </ng-template>
                            <ng-template ng-label-tmp let-selected="item">
                                <span>{{selected.clientName}} ({{selected.clientCode}})</span>
                            </ng-template>
                        </ng-select>  
                        <div *ngIf="(disbursementForm.submitted && clientDropdown.invalid)" class="invalid-feedback invalid">
                            Client is required
                        </div>                       
                    </div>
                  </div>
              </div>
            </div>   
            <div class="form-group form-group-sm">
                <div class="row align-items-top">
                    <h6 class="cmn-form-label mb-0 text-left col-3 disbursement-kc-cmd">Job<span class="color_field">*</span></h6>
                      <div class="col-7">
                        <div class="form-select-container">
                          <ng-select [items]="Invoicesummary" class="cmn-ngselect"
                                      bindLabel="jobName"
                                      bindValue="jobName"
                                      [clearable]="true" id="jobName" #jobName="ngModel"
                                      [(ngModel)]="disbursement.jobName"
                                      name="jobName"                                   
                                      required
                                      placeholder="Select job name"
                                      [selectOnTab]="true">
                                
                          </ng-select>       
                           <div *ngIf="(disbursementForm.submitted && jobName.invalid)" class="invalid-feedback invalid">
                                Job is required
                          </div>                    
                      </div>
                  </div>
              </div>
            </div>
            <div class="form-group form-group-sm">
              <div class="row align-items-top">
                <h6 class="cmn-form-label mb-0 text-left col-3 disbursement-kc-cmd">Date<span class="color_field">*</span></h6>
                <div class="col-7">
                  <div class="form-datepicker-container cmn-material-datepicker">
                    <input class="form-control form-dis-control" type="hidden" [(ngModel)]="disbursement.jobId" name="jobId" value="{{disbursement.jobId}}" id="jobId" />
                    <input class="form-control form-dis-control" type="hidden" [(ngModel)]="disbursement.disbursementId" value="{{disbursement.disbursementId}}" name="disbursementId" id="disbursementId" />
                    <mat-form-field floatLabel="never" appearance="standard">
                        <input class="cmn-mat-dtpicker-input" matInput
                               #disbursementDate="ngModel"
                               id="_iddisbursementDate"
                               (ngModelChange)="onDisbursementDateChange($event)"
                               [min]="invoiceMinDate"
                               [(ngModel)]="disbursement.disbursementDate" (ngModelChange)="disbursementCostCalc()" [matDatepicker]="disbursementDateDatepicker"
                               name="duedateS" autocomplete="off" placeholder="dd/mm/yyyy" required>
                        <mat-datepicker-toggle class="cmn-mat-dtpicker-togglebtn" matIconSuffix [for]="disbursementDateDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker panelClass="cmn-datepicker-ui"
                                        #disbursementDateDatepicker></mat-datepicker>
                        <mat-error class="cmn-material-datepicker-errormsg"
                                   *ngIf="!disbursementDate.hasError('matDatepickerMin')">
                            Please enter the date in dd/mm/yyyy
                        </mat-error>
                        <mat-error class="cmn-material-datepicker-errormsg"
                                   *ngIf="disbursementDate.hasError('matDatepickerMin')">
                            Date is in a closed period. Please select another.
                        </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm">
              <div class="row align-items-top">
                <h6 class="cmn-form-label mb-0 text-left col-3 disbursement-kc-cmd">Disbursement<span class="color_field">*</span></h6>
                <div class="col-7">
                  <div *ngIf="showdiselect">
                    <div class="form-select-container">                      
                      <ng-select [items]="disbursementMasterCombo" class="cmn-ngselect"
                                 bindLabel="name"
                                 bindValue="disbursementMasterId"
                                 [clearable]="true" id="disbursementName" #DisbursementName="ngModel" [(ngModel)]="disbursement.disbursementMasterRefId" name="disbursementMasterRefId" ngControl="disbursementMasterRefId" (change)="disbur($event)" required
                                 placeholder="Select disbursement"
                                 [selectOnTab]="true">

                        <ng-template ng-option-tmp let-item="item" let-index="index">
                          <span [title]="item.name" class=""> {{item.name.length > 35 ? (item.name| slice:0:35) + '..' : item.name}}</span>
                        </ng-template>
                      </ng-select>
                      <div *ngIf="disbursementForm.submitted && dropDownDisburseReq" class="invalid-feedback invalid">
                        Disbursement is required
                      </div>
                    </div>
                  </div>
                  <div *ngIf="showdistextbox">
                    <div class="form-input-container">
                      <input type="text" #DisbursementName="ngModel" [ngClass]="{ 'is-invalid':disbursementForm.submitted && DisbursementName.invalid }" class="form-control" name="name" id="_idName" placeholder="Name" [(ngModel)]="disbursement.name" (change)="Savedisname()" />
                      <div *ngIf="(disbursementForm.submitted && DisbursementName.invalid && disburseTextReq) || disburseTextReq" class="invalid-feedback invalid">
                        Name is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm">
              <div class="row align-items-top">
                <h6 class="cmn-form-label mb-0 text-left col-3 disbursement-kc-cmd">Description</h6>
                <div class="col-7">
                    <div class="form-textarea-container">
                        <textarea type="text" #Description="ngModel" name="description" id="_idDescription"
                                  (ngModelChange)="descriptionLabelChange($event);" maxlength="1500" style="height:70px !important"
                                  placeholder="Enter description" class="form-control" [(ngModel)]="disbursement.description" rows="2"></textarea>
                        <div class="float-end">{{ disbursement.description?.length || 0 }}/1500</div>
                        <div class="invalid-feedback invalid" *ngIf="disbursement.description?.length === 1500">
                            Character limit reached
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm">
              <div class="row align-items-top">
                <h6 class="cmn-form-label mb-0 text-left col-3 disbursement-kc-cmd">Supplier<span class="color_field">*</span></h6>
                <div class="col-7">
                  <div class="form-input-container">
                    <input type="text" class="form-control" name="supplierName"
                           #supplierName="ngModel"
                           [ngClass]="{ 'is-invalid': (disbursementForm.submitted && supplierName.invalid)   }"
                           id="_idsupplierName" placeholder="Supplier name" [(ngModel)]="disbursement.supplierName" required />
                    <div *ngIf="(disbursementForm.submitted && supplierName.invalid&&validateSupplierName)" class="invalid-feedback invalid">
                      <div *ngIf="supplierName.errors.required">
                        Supplier Name is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm">
              <div class="row align-items-top">
                <h6 class="cmn-form-label mb-0 text-left col-3 disbursement-kc-cmd">Tax rate<span class="color_field">*</span></h6>
                <div class="col-7">
                  <div class="form-select-container">
                    <ng-select [items]="taxTypes"
                               class="cmn-ngselect"
                               bindValue="taxTypeId"
                               placeholder="Select Tax rate"
                               name="gstType"
                               #gstType="ngModel"
                               [ngClass]="{ 'is-invalid': (disbursementForm.submitted && gstType.invalid) }"
                               [(ngModel)]="selectedTaxTypeId"
                               (ngModelChange)="disbursementCostCalc()"
                               required>
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.taxName }} ({{ item.taxRate }}%)
                      </ng-template>

                      <ng-template ng-label-tmp let-item="item">
                        {{ item.taxName }} ({{ item.taxRate }}%)
                      </ng-template>
                    </ng-select>
                    <div *ngIf="(disbursementForm.submitted && gstType.invalid)" class="invalid-feedback invalid">
                      <div *ngIf="gstType.errors?.required">
                        Tax rate is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm">
              <div class="row align-items-top">
                <h6 class="cmn-form-label mb-0 text-left col-3 disbursement-kc-cmd">No of units<span class="color_field">*</span></h6>
                <div class="col-7">
                  <div class="form-input-container">
                    <input OnlyNumber type="text" #noOfUnit="ngModel" [ngClass]="{ 'is-invalid':disbursementForm.submitted && noOfUnit.invalid }" class="form-control" name="noOfUnits" id="_idnoOfUnits" placeholder="Enter no of units" [(ngModel)]="disbursement.noOfUnits" (blur)="disbursementCostCalc()" (keypress)="numberOnly($event)" required />
                    <div *ngIf="(disbursementForm.submitted && noOfUnit.invalid&& validatenoOfUnits)" class="invalid-feedback invalid">
                      <div *ngIf="noOfUnit.errors.required">
                        No of units is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm">
              <div class="row align-items-top">
                <h6 class="cmn-form-label mb-0 text-left col-3 disbursement-kc-cmd">Unit cost<span class="color_field">*</span></h6>
                <div class="col-5">
                  <div class="form-input-container">
                    <div class="inputwith-dollar-prefix">
                      <input OnlyNumber type="text" #unitCost="ngModel" [ngClass]="{ 'is-invalid':disbursementForm.submitted && unitCost.invalid }" required class="form-control" name="unitCost" id="_idunitCost" [(ngModel)]="disbursement.unitCost" (keypress)="numberOnly($event)" (blur)="disbursementCostCalc()" />
                      <span class="prefix-square">
                        <img src="../../../assets/img/dollar-gray.svg" />
                      </span>
                    </div>
                    <div *ngIf="(disbursementForm.submitted && unitCost.invalid&& validateUnitCost) " class="invalid-feedback invalid">
                      <div *ngIf="unitCost.errors.required">
                        Unit cost is required
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Checkbox -->
                <div class="col-4 d-flex align-items-center">
                  <label class="custom-checkbox-container mt-2 mr-2" [class.disabled-checkbox]="isDisableIncludeTax">
                    <input type="checkbox"
                           [checked]="isIncludeTaxChecked"
                           [disabled]="isDisableIncludeTax"
                           (change)="toggleIncludeTax($event)" />
                    <span class="custom-checkbox"></span>
                    <span class="checkbox-label">Include tax</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm">
              <div class="row align-items-top">
                <h6 class="cmn-form-label mb-0 text-left col-3 font-weight-bold disbursement-kc-cmd">Subtotal</h6>
                <div class="col-7">
                  <div class="form-input-container total-input">
                    <div class="inputwith-dollar-prefix">
                      <input OnlyNumber type="text" class="form-control" name="subTotal" [(ngModel)]="disbursement.subTotal" />
                      <span class="prefix-square">
                        <img src="../../../assets/img/dollar-gray.svg" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm">
              <div class="row align-items-top">
                <h6 class="cmn-form-label mb-0 text-left col-3 disbursement-kc-cmd">GST value</h6>
                <div class="col-7">
                  <div class="form-input-container total-input">
                    <div class="inputwith-dollar-prefix">
                      <input OnlyNumber type="text" class="form-control" name="GSTValue" [(ngModel)]="disbursement.GSTValue" />
                      <span class="prefix-square">
                        <img src="../../../assets/img/dollar-gray.svg" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group form-group-sm">
              <div class="row align-items-top">
                <h6 class="cmn-form-label mb-0 text-left col-3 font-weight-bold disbursement-kc-cmd">Total</h6>
                <div class="col-7">
                  <div class="form-input-container total-input">
                    <div class="inputwith-dollar-prefix">
                      <input OnlyNumber type="text" class="form-control" name="total" [(ngModel)]="disbursement.total" />
                      <span class="prefix-square">
                        <img src="../../../assets/img/dollar-gray.svg" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cmn-modal-footer">
            <button type="submit" mat-button class="cmn-blue-btn">{{isEditDisbursement ? 'Update' : 'Add'}}</button>
            <button class="cmn-inverse-btn" mat-button data-dismiss="modal" (click)="closePopUp();cleandis(disbursementForm)">Cancel</button>
          </div>

        </div>
      </div>
    </div>

  </form>
